import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterFace, discountSectionsInterface} from "./discounstInterface";
import {setCustomAddedDiscounts, setDiscountSections} from "../../actions/priceWorksheetActions";
import DiscountCommon from "./discountCommon";
import DiscountNestedChild from "./discountNestedChild";
import uuid from "uuid";
import {getNextCustomDiscountOrder} from "./discountFunctions";
import store from "../../store";

class DiscountNestedParent extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterFace),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  componentDidMount() {
    const {discountSection, setCustomAddedDiscounts} = this.props;
    const customAddedDiscounts = store.getState().priceWorksheetState.customAddedDiscounts; // get every time latest
    if (!customAddedDiscounts.some(discount => discount.nestedParent && (discount.nestedParent === this.props.discount.uuId))) {
      const allNested = discountSection.discounts.filter(dis => dis.nestedParent && (dis.nestedParent === this.props.discount.uuId));
      const uuIdId = uuid();
      setCustomAddedDiscounts([...customAddedDiscounts, Object.assign({}, allNested[0], {
        categoryId: discountSection.id,
        id: uuIdId,
        uuId: uuIdId,
        order: getNextCustomDiscountOrder(this.props.discount)
      })]);
      this.props.setDiscountSections([...this.props.discountSections]); // update all price components
    }
  }

  render() {
    const {discountSection, customAddedDiscounts} = this.props;
    const nestedOptions = [
      {isEmpty: true},
      ...discountSection.discounts.filter(dis => dis.nestedParent && (dis.nestedParent === this.props.discount.uuId))
    ];
    if (nestedOptions.length === 1) {
      return null // just in case, cases when there is only empty option
    }
    const allSelectedNested = customAddedDiscounts.filter(discount => discount.nestedParent && (discount.nestedParent === this.props.discount.uuId));

    // console.log("allSelectedNested", allSelectedNested);

    return (
      <Fragment>
        {allSelectedNested.map((nestedChild, nestedChildIndex) => {
          return <DiscountNestedChild key={nestedChild.uuId}
                                      discount={nestedChild}
                                      parentDiscount={this.props.discount}
                                      nestedChildIndex={nestedChildIndex}
                                      nestedOptions={nestedOptions}
                                      allSelectedNested={allSelectedNested}
                                      discountSection={discountSection}/>
        })}
      </Fragment>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts} = store.priceWorksheetState;
  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorSettings: store.fabricatorState.settings,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setCustomAddedDiscounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountNestedParent);
